"use strict";

export class MobileMenu {
    #ROOT;
    #MENU;
    #TOGGLE_BTN;
    #QUERY;
    #HEADER;
    #HEADER_NAV;

    constructor() {
        this.#ROOT = document.querySelector("body");
        this.#MENU = this.#ROOT.querySelector("[data-mobile-menu]");
        this.#TOGGLE_BTN = this.#ROOT.querySelector("[data-togglebtn]");
        this.#QUERY = window.matchMedia("(min-width: 768px)");

        this.#HEADER = this.#ROOT.querySelector(".l-header");
        this.#HEADER_NAV = this.#ROOT.querySelector(".l-header__nav");

        this.initEvents();
        this.adjustMenuPosition();
    }

    adjustMenuPosition = () => {
        const adminBar = document.querySelector('#wpadminbar');
        let visibleAdminBarHeight = 0;
        if (adminBar) {
            const rect = adminBar.getBoundingClientRect();
            visibleAdminBarHeight = rect.bottom > 0 ? rect.bottom : 0;
        }

        const headerHeight = this.#HEADER ? this.#HEADER.offsetHeight : 64;

        document.documentElement.style.setProperty('--admin-bar-h', visibleAdminBarHeight + 'px');
        document.documentElement.style.setProperty('--header-h', headerHeight + 'px');
    };

    initEvents = () => {
        this.#TOGGLE_BTN.addEventListener("click", (e) => {
            e.preventDefault();
            this.#TOGGLE_BTN.classList.contains("is-active")
                ? this.hideDrawerNav()
                : this.showDrawerNav();
        });

        window.addEventListener("load", this.adjustMenuPosition);
        window.addEventListener("scroll", this.adjustMenuPosition, { passive: true });
        window.addEventListener("resize", this.adjustMenuPosition, { passive: true });

        if (this.#HEADER_NAV) {
            this.#HEADER_NAV.querySelectorAll("a").forEach(link => this.#bindAnchorLinkClick(link));
        }
        if (this.#MENU) {
            this.#MENU.querySelectorAll("a").forEach(link => this.#bindAnchorLinkClick(link));
        }
    };

    #bindAnchorLinkClick = (link) => {
        link.addEventListener("click", (e) => {
            const linkUrl = link.getAttribute("href");
            const headerEl = document.querySelector('header');

            if (linkUrl && linkUrl.includes("#")) {
                const currentPath = window.location.pathname;
                // link.pathname はブラウザによって / から始まるフルパスを返すため、
                // 比較対象として currentPath と同じ形式である必要があります
                const isSamePage = currentPath === link.pathname || link.pathname === "";

                // ★【重要】別ページへのアンカーリンクなら、何もしない（通常遷移させる）
                if (!isSamePage) return;

                // 以下、同一ページ内移動の場合のみの処理
                if (this.#TOGGLE_BTN.classList.contains("is-active")) {
                    e.preventDefault();
                    // ...（中略：同一ページ内の処理）
                    const htmlEl = document.documentElement;
                    htmlEl.classList.add("is-anchor-scrolling");
                    headerEl?.classList.add('--hide');
                    this.hideDrawerNav();

                    setTimeout(() => {
                        const targetElement = document.querySelector(link.hash);
                        targetElement?.scrollIntoView({ behavior: 'smooth' });
                        htmlEl.classList.remove("is-anchor-scrolling");
                        headerEl?.classList.remove('--hide');
                    }, 100);
                }
            }
        });
    };

    hideDrawerNav = () => {
        this.#TOGGLE_BTN.classList.remove("is-active");
        if (this.#MENU) this.#MENU.classList.remove("is-active");
        this.#ROOT.classList.remove("is-active");
        this.adjustMenuPosition();
    };

    showDrawerNav = () => {
        this.#TOGGLE_BTN.classList.add("is-active");
        if (this.#MENU) this.#MENU.classList.add("is-active");
        this.#ROOT.classList.add("is-active");
        this.adjustMenuPosition();
    };
}